import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import ActivitiesTab from './components/tabs/ActivitiesTab';
import HistoryTab from './components/tabs/HistoryTab';
import CreateActivityPage from './components/pages/CreateActivityPage';
import ActivityDetailPage from './components/pages/ActivityDetailPage';
import SubscriptionTab from './components/tabs/SubscriptionTab';
import LoginPage from './components/auth_pages/Login';
import AppNavbar from './components/navbars/AppNavbar';
import LandingPage from './components/pages/LandingPage';
import DataPrivacyPage from './components/pages/DataPrivacyPage';
import OutputTemplatesTab from './components/tabs/OutputTemplatesTab';
import RegisterPage from './components/auth_pages/RegisterPage';
import ForgotPasswordPage from './components/auth_pages/ForgotPasswordPage';
import ResetPasswordPage from './components/auth_pages/ResetPasswordPage';
import ActivateAccountPage from './components/auth_pages/ActivateAccountPage';

import './styles/App.css';

function Layout() {
  const location = useLocation();

  // Define routes where the core app navbar should NOT be displayed
  const hideNavbarRoutes = ["/", "/data-privacy", "/login", "/auth/register", "/auth/forgot-password", "/auth/reset-password", "/auth/activate"];

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <AppNavbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/register" element={<RegisterPage />} />
        <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth/activate" element={<ActivateAccountPage />} />

        <Route path="/aktivity" element={<ActivitiesTab />} />
        <Route path="/historia" element={<HistoryTab />} />
        <Route path="/vzory-vystupu" element={<OutputTemplatesTab />} />
        <Route path="/spotreba" element={<SubscriptionTab />} />
        <Route path="/vytvor-aktivitu" element={<CreateActivityPage />} />
        <Route path="/aktivita/:id" element={<ActivityDetailPage />} />
        <Route path="/data-privacy" element={<DataPrivacyPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
